import {commitMutation, Disposable, Environment, graphql} from 'react-relay';
import Util from '../../../forecast-app/shared/util/util';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../../MutationTypes';
import {
	UpdateOutlookCalendarInput,
	UpdateOutlookCalendarMutation,
	UpdateOutlookCalendarMutation$rawResponse,
} from './__generated__/UpdateOutlookCalendarMutation.graphql';

const mutation = graphql`
	mutation UpdateOutlookCalendarMutation($input: UpdateOutlookCalendarInput!) @raw_response_type {
		updateOutlookCalendar(input: $input) {
			outlookCalendar {
				calendarViewPrivateEvents
				enabledCalendars
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: MutationInput<UpdateOutlookCalendarInput>,
	onSuccess: RelayOnCompleted<UpdateOutlookCalendarMutation>,
	onError: RelayOnError
): Disposable {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};

	const optimisticResponse: UpdateOutlookCalendarMutation$rawResponse = {
		updateOutlookCalendar: {
			outlookCalendar: {
				id: input.id as string,
				calendarViewPrivateEvents: input.viewPrivateEvents ?? null,
				enabledCalendars: input.enabledCalendarIds ?? null,
			},
		},
	};
	return commitMutation<UpdateOutlookCalendarMutation>(environment, {
		mutation,
		variables,
		optimisticResponse,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
